import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
    ContentInspectionConnectorService
} from '@finder/shared/services/content-inspection-connector/content-inspection-connector.service';
import { LoadingService } from '@finder/shared/services/loading-service/loading-service.service';
import { THEMES } from '@finder/shared/constants/app.constants';
import { FinderThemeService } from '../services/theme-service/finder-theme.service';

@Injectable()
export class EveResolver implements Resolve<any> {
    constructor(
        private contentInspectionApi: ContentInspectionConnectorService,
        private loadingService: LoadingService,
        private themeService: FinderThemeService,
    ) {}

    resolve() {
        this.loadingService.setErrorState(null);
        this.loadingService.setLoadingState(false);

        /**
         * Use a promise to resolve the route and never reject
         * the error so we can stay on the same URI
         */
        return new Promise((resolve) => {
            this.contentInspectionApi.getEveFormConfig()
                .pipe(
                    catchError((error) => {
                        this.loadingService.setErrorState(error);
                        this.loadingService.setLoadingState(true);

                        // This doesn't really do anything other an stop the error from a
                        // method that wants an Observable returned to it
                        return EMPTY;
                    })
                ).subscribe((result) => {
                    // Disable loading spinner
                    this.loadingService.setLoadingState(true);
                    this.themeService.setCurrentTheme(THEMES.EVE);
                    resolve(result);
                });
        });
    }
}
